import { render, staticRenderFns } from "./something-went-wrong.vue?vue&type=template&id=933b2270&scoped=true&"
import script from "./something-went-wrong.vue?vue&type=script&lang=js&"
export * from "./something-went-wrong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933b2270",
  null
  
)

export default component.exports